/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
if (!Math.PI_2) {
	Math.PI_2 = Math.PI / 2;
}

if (!Math.PI_4) {
	Math.PI_4 = Math.PI / 4;
}

if (!Math.PI_8) {
	Math.PI_8 = Math.PI / 8;
}

module.exports = Math;



// WEBPACK FOOTER //
// ../jsg-core/src/commons/Math.js